import React from 'react';
import PropTypes from 'prop-types';

/**
 * @typedef {Object} CalciteScrimProps
 * @property {string} [className] - The class name to apply to the component.
 * @property {boolean} [loading] - Whether the scrim is loading.
 * @property {React.ReactNode} [children] - The children of the component.
 */
const CalciteScrim = ({className, loading, children, ...rest}) => {
  return (
    <calcite-scrim class={className} loading={loading || undefined} {...rest}>
      {children}
    </calcite-scrim>
  );
};

CalciteScrim.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  children: PropTypes.node,
};

export default CalciteScrim;
